import { createContext, useState } from 'react'
import { ExperienceOptionsProps } from 'src/components/communitySurvey/createCommunitySurvey/steps/communityCreationExperience/communityCreationExperience.types'
import { FirstPostSurvey } from 'src/components/communitySurvey/firstPostSurvey'
import { useUser } from 'src/hook/useUser'
import { FIRST_POST_SURVEY_BASE_KEY } from 'src/components/communitySurvey/communityModalSurvey.constants'
import {
  FirstPostSurveyContextProps,
  FirstPostSurveyProviderProps
} from './firstPostSurveyContext.types'

export const FirstPostSurveyContext = createContext<FirstPostSurveyContextProps | null>(null)

export const FirstPostSurveyProvider = ({ children }: FirstPostSurveyProviderProps) => {
  const { user } = useUser()
  const [firstPostExperienceValue, setFirstPostExperienceValue] = useState<
    ExperienceOptionsProps | undefined
  >()
  const [firstPostImprovementText, setFirstPostImprovementText] = useState('')
  const [firstPostChallengeText, setFirstPostChallengeText] = useState('')
  const [isFirstPostSurveyOpen, setIsFirstPostSurveyOpen] = useState(false)
  const FIRST_POST_SURVEY_KEY = `${FIRST_POST_SURVEY_BASE_KEY}_${user.ucode}`

  return (
    <FirstPostSurveyContext.Provider
      value={{
        firstPostExperienceValue,
        setFirstPostExperienceValue,
        firstPostImprovementText,
        setFirstPostImprovementText,
        firstPostChallengeText,
        setIsFirstPostSurveyOpen,
        isFirstPostSurveyOpen,
        setFirstPostChallengeText,
        FIRST_POST_SURVEY_KEY
      }}
    >
      <FirstPostSurvey
        isOpen={isFirstPostSurveyOpen}
        onClose={() => setIsFirstPostSurveyOpen(false)}
      />
      {children}
    </FirstPostSurveyContext.Provider>
  )
}
